<template>
  <div class="">
    <hr>
    <p class="badge badge-pill badge-warning text-capitalize">{{ item.type }}</p>
    <div class="form-group">
      <input type="text" class="mb-2 form-control" v-model="item.title">
      <textarea disabled class="form-control" id="exampleFormControlTextarea1" rows="3"></textarea>
    </div>
    <b-icon class="bg-danger d-inline p-1 rounded-pill mx-2 h3 text-white  my-2" icon="trash" @click="deleteQuestion()"/>
  </div>
</template>

<script>
import {generateHash} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/ShoppingCart";

export default {
  name: "TextareaInput",
  props: {
    item: {}
  },
  computed: {
    generateHashComputed() {
      return generateHash()
    }
  },
  methods:{
    deleteQuestion() {
      this.$emit('removeQuestion')
    }
  }
}
</script>

<style scoped>

</style>